import { PaymentsApi } from "@/api/payments";
import { QueryKey } from "@/utils";
import { useQuery } from "@tanstack/react-query";

export const useGetSubscriptionPlans = () => {
  const { data } = useQuery({
    queryKey: [QueryKey.SUBSCRIPTION_PLANS],
    queryFn: () => PaymentsApi.getSubscriptionPlans(),
  });

  return { subscriptionPlans: data };
};
